import { autoinject, bindable } from 'aurelia-framework';
import { AccountingRule, IAccountingRule, IAccountingRuleFolder, MissingServiceTargetingRule } from "./accounting-rule-models";
import { ResponseHandler } from '../../utils/response-handler';
import { noop } from "lodash";
import { AccountingRuleApi } from "./accounting-rule-api";

@autoinject
export class ServiceTargetingMissingList {
	@bindable scopeId: string;
	@bindable scopeIsClosed: boolean;
	@bindable ruleInserted: (rule: any) => void;
	@bindable missingServiceTargetingRules: MissingServiceTargetingRule[];
	@bindable folders: IAccountingRuleFolder[];

	inProgress = true;

	constructor(private api: AccountingRuleApi, private responseHandler: ResponseHandler) {
	}

	insertSucceeded(addedRule: IAccountingRule, source: MissingServiceTargetingRule): void {
		const index = this.missingServiceTargetingRules.indexOf(source);
		this.missingServiceTargetingRules.splice(index, 1);

		const newRule = AccountingRule.createNew(addedRule);
		(this.ruleInserted || noop)({ rule: newRule });
	}

	async refreshAccountinRules() {
		this.missingServiceTargetingRules = await this.api.getMissingServiceTargetingRules(this.scopeId);
	}

	attached() {
		if (!this.missingServiceTargetingRules) {
			this.refreshAccountinRules();
		}
	}

	toggleRule(rule: AccountingRule) {
		rule.expanded = !rule.expanded;
		return true;
	}
}
